import getSplashApiClient from 'lib/SplashApiClient/singleton';

/**
 * Wraps a SplashApiClient with the Events Dashboard API actions
 */
export default class EventSettingsApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    getEventSettings(eventId) {
        return this.apiClient.get(`/events/${eventId}/settings`);
    }

    saveEventSettings(eventId, formData) {
        return this.apiClient.patch(`/events/${eventId}/settings`, formData);
    }

    /**
     * [saveSetings description]
     * @return {promise}
     */
    saveSettings() {
        return Promise.resolve();
    }
}

export const getEventSettingsApiClient = () => new EventSettingsApiClient(getSplashApiClient());
